import { IconButton, Stack } from '@mui/material';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';

import styles from './TransferControls.module.scss';

interface IControlProps {
  onMoveRight: () => void;
  onMoveLeft: () => void;
  disableRight: boolean;
  disableLeft: boolean;
}

const TransferControls = ({
  onMoveRight,
  onMoveLeft,
  disableRight,
  disableLeft,
}: IControlProps) => (
  <Stack spacing={2} className={styles.controlsContainer}>
    <IconButton
      onClick={onMoveRight}
      disabled={disableRight}
      className={styles.transferButton}
      disableRipple
    >
      <KeyboardDoubleArrowRightIcon />
    </IconButton>

    <IconButton
      onClick={onMoveLeft}
      disabled={disableLeft}
      className={styles.transferButton}
      disableRipple
    >
      <KeyboardDoubleArrowLeftIcon />
    </IconButton>
  </Stack>
);

export default TransferControls;
